import {useSelector} from 'react-redux';

import {useGetParticipationQuery} from '@dms/api/core';
import {EntityResourceIds} from '@dms/api/shared';
import {selectSaleVehicle} from '@dms/api/vehicle';
import {usePermissions} from '@dms/shared';

/**
 * Caris service request actions need both the licence-backed Caris action and the right to
 * update this vehicle (scoped by participation and branch).
 */
export const useCarisServiceRequestPermissions = (vehicleId: string) => {
  const {data: saleVehicle} = useSelector(selectSaleVehicle(vehicleId));
  const {data: vehicleParticipation} = useGetParticipationQuery({
    resourceId: EntityResourceIds.vehicle,
    recordId: vehicleId,
  });

  const [canUpdateVehicle, canCreateCarisServiceRequest, canCancelCarisServiceRequest] =
    usePermissions({
      permissionKeys: ['updateVehicle', 'createCarisServiceRequest', 'cancelCarisServiceRequest'],
      scopes: {
        updateVehicle: {participation: vehicleParticipation, branchId: saleVehicle?.branchId},
      },
    });

  return {
    canCreate: canUpdateVehicle && canCreateCarisServiceRequest,
    canCancel: canUpdateVehicle && canCancelCarisServiceRequest,
  };
};
